const services = [
  {
    title: "Accounting & Bookkeeping",
    description:
      "Automate your entire accounting cycle — from daily transactions to compliant financial reports.",
    icon: "📊",
    details: "Fully aligned with FTA & IFRS standards.",
    fullDetails:
      "Our comprehensive accounting and bookkeeping service takes the stress out of financial management. From recording daily transactions and managing ledgers to preparing error-free financial statements, we handle it all. Using automation and expert oversight, we ensure your books stay clean, compliant with FTA and IFRS regulations, and always up to date. Gain real-time insights, reduce manual errors, and make informed decisions — all while saving valuable time and operational costs.",
  },
  {
    title: "Tax Services",
    description:
      "Ensure tax compliance and reduce penalties with expert guidance and automation.",
    icon: "💼",
    details: "Save time and cut costs — up to 80% on tax-related expenses.",
    fullDetails:
      "Our tax services go beyond basic filing — we become your strategic tax partner. From VAT registration and returns to tax planning and risk mitigation, our experts ensure full regulatory compliance while identifying opportunities to minimize liabilities. Our automated workflows reduce human error and keep you ahead of deadlines. Whether you're a startup or a growing business, we help you navigate complex tax landscapes confidently, with up to 80% savings on time and expenses.",
  },
  {
    title: "CFO Services",
    description:
      "Plan, optimize, and scale your business finances with strategic CFO support.",
    icon: "📈",
    details:
      "From budgeting to future-proofing your business with certified experts.",
    fullDetails:
      "Our virtual CFO services offer high-level financial leadership without the cost of a full-time executive. We help you design budgets, forecast cash flow, evaluate investments, and implement smart cost-control strategies tailored to your goals. Our team of certified financial experts becomes your trusted partner in long-term planning and decision-making. Whether you’re scaling operations or preparing for investors, we make sure your finances are growth-ready and future-proof.",
  },
  {
    title: "Mobile Application",
    description: "Manage your finances on the go with our smart mobile app.",
    icon: "📱",
    details:
      "Scan, upload, and track all your receipts and financial documents effortlessly.",
    fullDetails:
      "With the Morph mobile app, managing your finances has never been more convenient. Designed for entrepreneurs and busy business owners, the app lets you scan, upload, and track receipts, invoices, and documents from anywhere. Our AI automatically reads and categorizes entries, syncing them with your financial records in real time. Stay organized, monitor performance, and ensure compliance — right from your pocket. It’s your personal accountant, wherever you go.",
  },
  {
    title: "Financial Reporting",
    description:
      "Get real-time insights and monthly/quarterly reports tailored for smart decision-making.",
    icon: "📑",
    details: "Understand performance and stay audit-ready at all times.",
    fullDetails:
      "Our financial reporting service transforms raw numbers into clear, actionable insights. Receive professionally prepared monthly, quarterly, and annual reports customized to your industry and business goals. We don’t just report the data — we help you understand it. From profit and loss breakdowns to cash flow summaries and KPI tracking, you get the visibility you need to optimize performance, reduce risk, and confidently lead your business forward.",
  },
  {
    title: "Audit & Compliance Support",
    description:
      "Never stress over audits again — we store and organize your financial data for full audit readiness.",
    icon: "🔍",
    details: "Peace of mind during audits with end-to-end expert support.",
    fullDetails:
      "Audits can be stressful — but they don’t have to be. We ensure your financial records are meticulously organized, securely stored, and always audit-ready. Our experts support you before, during, and after any audit process — whether internal or external. From preparing documents to responding to inquiries, we help you navigate every step with confidence. Let us handle the paperwork so you can focus on running your business without disruptions.",
  },
];

export default services;